import { motion } from "framer-motion";
import { Cookie, Droplets, Check, ArrowRight } from "lucide-react";
import { Reveal, Label } from "./motion";
import { IMAGES, scrollToId } from "@/data/content";

const PRODUCTS = [
  {
    key: "chews",
    icon: Cookie,
    image: IMAGES.chews,
    name: "CBDoodle Soft Treats",
    subtitle: "Daily Comfort Chews",
    tagline: "Tasty, easy, and made for picky seniors.",
    highlights: [
      "Turkey & sweet-potato flavour dogs love",
      "Soft, gentle texture for aging teeth",
      "Perfect for daily routines & rewards",
    ],
    bestFor: "Best for convenience & taste",
    cardTestid: "cbdoodle-product-chews-card",
    ctaTestid: "cbdoodle-product-chews-cta",
  },
  {
    key: "tincture",
    icon: Droplets,
    image: IMAGES.tincture,
    name: "CBDoodle Tincture / Oil",
    subtitle: "Precision Sublingual Drops",
    tagline: "Exact, weight-based dosing with faster absorption.",
    highlights: [
      "Calibrated dropper for precise dosing",
      "Under the tongue or mixed into food",
      "Ideal for toy, mini & standard poodles",
    ],
    bestFor: "Best for precise dosing & absorption",
    cardTestid: "cbdoodle-product-tincture-card",
    ctaTestid: "cbdoodle-product-tincture-cta",
  },
];

export const Products = () => (
  <section id="products" className="bg-[#F3EDE2] px-5 py-20 sm:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal><Label>The Concept Range</Label></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight text-[#2C2B29] sm:text-4xl lg:text-[2.9rem]">
            Two gentle ways to support your poodle
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-4 max-w-lg font-sans leading-relaxed text-[#5C5850]">
            A concept showcase — the exact formula will be finalized with veterinary guidance. Reserve early
            access to help shape it.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-7 lg:grid-cols-2">
        {PRODUCTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.key} delay={i * 0.12} data-testid={p.cardTestid}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                className="group flex h-full flex-col overflow-hidden rounded-[2rem] border border-[#C58F3B]/25 bg-[#FFFDF9] shadow-sm transition-shadow duration-300 hover:shadow-2xl"
              >
                <div className="relative">
                  <img src={p.image} alt={p.name} className="h-64 w-full object-cover sm:h-72" />
                  <span className="absolute left-5 top-5 rounded-full bg-[#2D4338] px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-[#F3EDE2]">
                    Coming Soon
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-7">
                  <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#E2ECE7] text-[#4A6B5D]">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-serif text-2xl font-semibold text-[#2C2B29]">{p.name}</h3>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.18em] text-[#C58F3B]">{p.subtitle}</p>
                  <p className="mt-3 font-sans text-[15px] italic text-[#5C5850]">{p.tagline}</p>

                  <ul className="mt-5 space-y-2.5">
                    {p.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2.5 font-sans text-sm text-[#2C2B29]">
                        <Check size={16} className="mt-0.5 flex-none text-[#4A6B5D]" strokeWidth={2.5} />
                        {h}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-6 flex items-center gap-2 rounded-full bg-[#FDF6E7] px-4 py-2 font-sans text-xs font-medium text-[#B07D2B]">
                    {p.bestFor}
                  </div>

                  <button
                    data-testid={p.ctaTestid}
                    onClick={() => scrollToId("waitlist")}
                    className="group/btn mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#C58F3B] px-6 py-3.5 font-sans text-[15px] font-medium text-white transition-all duration-200 hover:bg-[#B07D2B] active:scale-[0.98]"
                  >
                    Reserve Early Access
                    <ArrowRight size={16} className="transition-transform duration-200 group-hover/btn:translate-x-1" />
                  </button>
                </div>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
